import * as React from 'react';
import styled from 'styled-components';
import { compose, space, color, layout, typography, SpaceProps, ColorProps, LayoutProps, TypographyProps } from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement> & {
  title?: any;
}>(({
  title,
  ...props
}, svgRef) => {
  const [titleId] = React.useState(() => title ? nanoid() : undefined);
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="1em" height="1em" ref={svgRef} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M11.84 5.746a1.032 1.032 0 00-.091.092l-8.064 8.063a3 3 0 00-.79 1.394l-.865 3.463a1 1 0 001.213 1.212l3.463-.866a3 3 0 001.393-.789l8.092-8.092a.905.905 0 00.034-.034l1.861-1.86a3.121 3.121 0 00-4.413-4.414l-1.832 1.831zm3.247-.418a1.121 1.121 0 111.585 1.586l-1.17 1.17L13.915 6.5l1.171-1.17zm-1 4.17l-7.402 7.403a1 1 0 01-.465.263l-1.845.462.461-1.846a1 1 0 01.263-.465l7.403-7.401 1.585 1.585zm7.969 7.798a1 1 0 010 1.414l-1.094 1.094a4.095 4.095 0 01-5.79.001 2.101 2.101 0 00-2.966 0 1 1 0 11-1.412-1.416 4.101 4.101 0 015.79 0v.001a2.095 2.095 0 002.963 0l1.095-1.094a1 1 0 011.414 0z" clipRule="evenodd" /></svg>;
});
export const IconSystemV2SpecificPenCurve = styled(SvgComponent)<IconProps>({
  flex: 'none',
  verticalAlign: 'middle'
}, compose(space, color, layout, typography));
